<template>
  <div>
    <div>
      <el-select v-model="addIns" placeholder="选择需要添加的乐器" filterable>
        <el-option v-for="(name, id) in instrumentMap" :key="id" :label="name + ' - ' + id" :value="id"></el-option>
      </el-select>
      <el-button type="primary" @click="_handleAddIns" style="margin-left: 8px;">添 加</el-button>
    </div>
    <el-table :data="insData">
      <el-table-column label="名称" prop="name"></el-table-column>
      <el-table-column label="值">
        <template slot-scope="{ row }">
          <el-input v-model.trim="row.value" placeholder=""></el-input>
        </template>
      </el-table-column>
      <el-table-column label="" width="100">
        <template slot-scope="{ row, index }">
          <i class="el-icon-delete" @click="_handleRemove(index)" />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { instrumentMap } from '../mixin.js'

const NOT_SHOW_KEYS = ['insertTime', 'modifyTime', 'id']

export default {
  name: 'Instrument',
  props: {
    ins: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      instrumentMap,
      addIns: '',
      insData: [],
      metaInfo: []
    }
  },
  created() {
    this._initTableData()
  },
  methods: {
    _handleAddIns() {
      if (this.addIns && !this.insData.find(item => item.key === this.addIns)) {
        this.insData.push({
          name: instrumentMap[this.addIns],
          value: '',
          key: this.addIns
        })
      }
    },

    _handleRemove(index) {
      this.insData.splice(index, 1)
    },

    _initTableData() {
      this.insData = Object.keys(this.ins).filter(key => {
        if (NOT_SHOW_KEYS.includes(key)) {
          this.metaInfo.push({
            value: this.ins[key],
            key
          })
        }
        return key && this.ins[key] && !NOT_SHOW_KEYS.includes(key)
      }).map(key => {
        return {
          name: instrumentMap[key],
          value: this.ins[key],
          key
        }
      })
    },

    /**
     * @public
     */
    getData() {
      return [...this.insData, ...this.metaInfo]
    }
  }
}
</script>

<style scoped lang="scss">
.el-icon-delete {
  cursor: pointer;

  &:hover {
    color: red;
  }
}
</style>
